import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import ReviewsList from './ReviewsList';
import { X, Heart, CreditCard, Loader2, Star } from 'lucide-react';

export const TipModal = ({ show, onClose, profile, tipAmount, setTipAmount, onSendTip, tipLoading }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-sm mx-4 p-6">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"><X className="h-5 w-5" /></button>
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Heart className="h-8 w-8 text-pink-500" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">Envoyer un tip a {profile?.display_name}</h3>
          <p className="text-sm text-gray-500">Soutenez ce createur en lui envoyant un pourboire</p>
        </div>
        <div className="grid grid-cols-3 gap-2 mb-4">
          {[5, 10, 25].map((amount) => (
            <button key={amount} onClick={() => setTipAmount(amount.toString())} className={`py-3 rounded-xl border-2 font-semibold transition-all ${
              tipAmount === amount.toString() ? 'border-pink-500 bg-pink-50 text-pink-600' : 'border-gray-200 text-gray-700 hover:border-gray-300'
            }`}>{amount} CHF</button>
          ))}
        </div>
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Ou entrez un montant personnalise</label>
          <div className="relative">
            <Input type="number" min="1" max="500" step="0.5" value={tipAmount} onChange={(e) => setTipAmount(e.target.value)} placeholder="Montant" className="pr-14" />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">CHF</span>
          </div>
          <p className="text-xs text-gray-400 mt-1">Min: 1 CHF / Max: 500 CHF</p>
        </div>
        <Button onClick={onSendTip} disabled={!tipAmount || parseFloat(tipAmount) < 1 || tipLoading} className="w-full bg-gradient-to-r from-pink-500 to-purple-500 text-white py-3">
          {tipLoading ? <Loader2 className="h-5 w-5 animate-spin mr-2" /> : <CreditCard className="h-5 w-5 mr-2" />}
          Envoyer {tipAmount || '0'} CHF
        </Button>
      </div>
    </div>
  );
};

export const ReviewsModal = ({ show, onClose, profile, userId }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-2xl mx-4 max-h-[80vh] overflow-hidden">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h3 className="text-xl font-bold text-gray-900 flex items-center">
            <Star className="h-5 w-5 mr-2 text-yellow-500" />Avis sur {profile?.display_name}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-testid="close-reviews-modal"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
          <ReviewsList userId={userId} showTitle={false} limit={20} />
        </div>
      </div>
    </div>
  );
};
